import { updateField } from 'vuex-map-fields'
import { DebugSocket } from 'services'
import { FlowStateEnum } from 'enums'
import moment from 'moment'

export default {
  openDebugSocket(state, config: { host: ?string, port: ?number, securePort: ?number }) {
    state.debugSocket = DebugSocket(config)
  },
  closeDebugSocket(state) {
    if (state.debugSocket) {
      state.debugSocket.remove()
      state.debugSocket = null
      state.flowDebugState = FlowStateEnum.STOPPED
    }
  },
  setFlowDebugState(state, flowState) {
    state.flowDebugState = flowState
  },
  addLog(state, { runState, step }) {
    const ts = moment().format('HH:mm:ss.SSS')
    state.logs = [...state.logs, { ts: ts, log: step, state: runState }]
  },
  clearLog(state) {
    state.logs = []
  },
  setDebugInputs(state, inputs) {
    state.debugInputs = inputs
  },
  setDebugDelay(state, delay) {
    state.debugDelay = delay
  },
  setDebugSocketState(state, socketState) {
    state.debugSocketState = socketState
  },
  setDebugSocketConf(state, socketConf) {
    state.debugSocketConf = socketConf
  },
  setStellerDetected(state, value) {
    state.stellerDetected = value
  },
  updateField
}
